/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 13:59:24
 * @LastEditTime: 2021-12-03 13:45:01
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/ShippingCondition/index.tsx
 */

import { Label, NumberInput, Select } from '@/src/components/Antd';
import { unitSuffix, unitTypeList } from '@/src/tools/config';
import { ConditionType, UnitType } from '@/src/types/common/common';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

const ShippingCondition = ({ form }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleConditionTypeChange = (value) => {
    if (value == ConditionType.Size) {
      form.setFields([
        {
          name: ['shippingCondition', 'volumeUnit'],
          value: UnitType.CubicMetre,
        },
      ]);
    } else {
      form.setFields([
        { name: ['shippingCondition', 'weightUnit'], value: UnitType.Kilogram },
      ]);
    }
  };

  const handleMinimumOrderWeight = () => {
    form.validateFields([['shippingCondition', 'max']]);
  };
  return (
    <div className={css.itemBlock}>
      <div className={css.header}>
        <div className={css.title}>
          {getI18n('storeLogistics.components.shippingCondition')}
        </div>
      </div>
      <div className={`${css.itemContent} ${css.content}`}>
        <div className={css.shippingCondition}>
          <Form.Item
            className={css.deliveryMethodName}
            name={['shippingCondition', 'conditionType']}
            label={getI18n('storeLogistics.components.conditionType')}>
            <Select
              size='large'
              onChange={handleConditionTypeChange}
              optionsList={[
                {
                  label: getI18n('storeLogistics.components.orderWeight'),
                  value: ConditionType.Weight,
                },
                {
                  label: getI18n('storeLogistics.components.orderSize'),
                  value: ConditionType.Size,
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'shippingCondition.conditionType', '') !==
              get(currentValues, 'shippingCondition.conditionType', '')
            }>
            {({ getFieldValue }) => {
              const conditionType = getFieldValue([
                'shippingCondition',
                'conditionType',
              ]);
              const name =
                conditionType === ConditionType.Weight
                  ? 'weightUnit'
                  : 'volumeUnit';
              return (
                <Form.Item
                  className={css.deliveryMethodName}
                  name={['shippingCondition', name]}
                  label={getI18n('storeLogistics.components.unitofMeasure')}>
                  <Select
                    size='large'
                    optionsGroupList={unitTypeList[conditionType]}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </div>
        <div className={css.shippingCondition}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'shippingCondition.conditionType', '') !==
                get(currentValues, 'shippingCondition.conditionType', '') ||
              get(prevValues, 'shippingCondition.weightUnit', '') !==
                get(currentValues, 'shippingCondition.weightUnit', '') ||
              get(prevValues, 'shippingCondition.volumeUnit', '') !==
                get(currentValues, 'shippingCondition.volumeUnit', '') ||
              get(prevValues, 'shippingCondition.min', '') !==
                get(currentValues, 'shippingCondition.min', '')
            }>
            {({ getFieldValue }) => {
              const conditionType = getFieldValue([
                'shippingCondition',
                'conditionType',
              ]);
              const weightUnit = getFieldValue([
                'shippingCondition',
                'weightUnit',
              ]);
              const volumeUnit = getFieldValue([
                'shippingCondition',
                'volumeUnit',
              ]);
              const unit =
                conditionType === ConditionType.Weight
                  ? weightUnit
                  : volumeUnit;

              return (
                <Fragment>
                  <Form.Item
                    className={css.deliveryMethodName}
                    name={['shippingCondition', 'min']}
                    label={
                      <Label
                        title={`${getI18n(
                          'storeLogistics.components.minimumOrderWeight',
                        )} (>=)`}
                        rightSubTitle=' '
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n(
                            'storeLogistics.components.minimumOrderWeight',
                          ),
                        ),
                      },
                    ]}>
                    <NumberInput
                      size='large'
                      min={0}
                      onChange={handleMinimumOrderWeight}
                      suffix={unitSuffix[unit]}
                    />
                  </Form.Item>
                  <Form.Item
                    className={css.maximumOrderWeight}
                    name={['shippingCondition', 'max']}
                    label={
                      <Label
                        title={`${getI18n(
                          'storeLogistics.components.maximumOrderWeight',
                        )} (<)`}
                        rightSubTitle={getI18n(
                          'storeLogistics.components.maximumOrderWeightSubTitle',
                        )}
                      />
                    }
                    rules={[
                      {
                        type: 'number',
                        min: getFieldValue(['shippingCondition', 'min']),
                        message: getI18n(
                          'storeLogistics.components.maximumOrderWeightInvalid',
                        ),
                      },
                    ]}>
                    <NumberInput
                      size='large'
                      placeholder={getI18n('storeLogistics.components.nolimit')}
                      suffix={unitSuffix[unit]}
                    />
                  </Form.Item>
                </Fragment>
              );
            }}
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default ShippingCondition;
